import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data";
import { Reveal } from "./Reveal";

export const Services = () => {
  const scrollTo = () => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services" className="bg-bone py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-terra" />
              <span className="text-pine/60 text-xs uppercase tracking-[0.3em]">What we do</span>
            </div>
            <Reveal>
              <h2 className="font-display font-extrabold text-pine tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
                Full exterior property care, start to finish.
              </h2>
            </Reveal>
          </div>
          <p className="text-pine/70 text-base md:text-lg max-w-sm leading-relaxed">
            Tree removal is the heart of what we do — but we handle everything that keeps your
            property safe, clear, and looking its best.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-stone">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={(i % 3) * 0.08}>
              <button
                data-testid={`service-card-${s.n}`}
                onClick={scrollTo}
                className="group relative w-full text-left border-b border-r border-stone p-8 md:p-10 h-full flex flex-col bg-bone hover:bg-pine transition-colors duration-500"
              >
                <div className="img-clip aspect-[16/10] mb-7">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
                </div>
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <span className="font-display text-terra text-sm font-bold">{s.n}</span>
                    <h3 className="font-display font-bold text-2xl tracking-tight mt-1 text-pine group-hover:text-bone transition-colors duration-500">
                      {s.title}
                    </h3>
                  </div>
                  <ArrowUpRight
                    className="text-pine/40 group-hover:text-terra group-hover:rotate-0 -rotate-45 transition-all duration-500 shrink-0"
                    size={24}
                  />
                </div>
                <p className="mt-4 text-pine/65 group-hover:text-bone/70 text-sm leading-relaxed transition-colors duration-500">
                  {s.desc}
                </p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
